import React from 'react'

const Approach = () => {
  return (
    <div className='approach' id='approach'>
      
      <div className='sec1-about'>
        <p className='head-about'>You are now entering my 'Approach' section</p>
        <p className='tag-about'>2</p>
      </div>

      <div className='main-approach'>
        <div>
          <p className='p1-main-approach'>My Mission:</p>
          <div className='p2-main-approach'>
            <p className='p2-main-approachp'>Finetuning the process behind method and creativity.</p>
            <p className='line-approach'></p>
          </div>
        </div>

        <div>
          <p className='p1-main-approach'>Challenge :</p>
          <div className='p2-main-approach'>
            <p className='p2-main-approachp'>Combining technical expertise with a creative vision.</p>
            <p className='line-approach'></p>
          </div>
        </div>

        <div>
          <p className='p1-main-approach'>Solution :</p>
          <div className='p2-main-approach'>
            <p className='p2-main-approachp'>Craft unique experiences that brands didn’t know they need</p>
          </div>
        </div>
      </div>
    
    </div>
  )
}

export default Approach
